var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1039 1640.8",
    style: {
      enableBackground: "new 0 0 1039 1640.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#A2A2A2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "601.1,411.4 663.5,349 519.5,204.9 375.5,349 437.9,411.4 519.5,493  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.5,803.6l187,179.3l187-179.3L1039,484.8l-262.4-43.9l91.9-91.8L519.5,0l-349,349l91.9,91.8L0,484.8 L332.5,803.6z M375.5,349l144-144.1l144,144.1l-62.4,62.4L519.5,493l-81.6-81.6L375.5,349z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "519.5,1052.8 332.5,873.6 138.3,698 249.3,1640.8 519.5,1640.8 789.7,1640.8 887,698 706.5,873.6  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTower);
export default __webpack_public_path__ + "static/media/tower.c68cae9566778ad9c7927e3360e3f83b.svg";
export { ForwardRef as ReactComponent };